import { MessageSquare } from 'lucide-react';

/**
 * C20-138 — Empty body shown when a chat session has no messages yet.
 *
 * Visual contract: the prototype's chat surface (lines 545-607 of
 * `screens-engagement.js`) always shows the input footer with the
 * suggested-prompt chip row. The empty body above the input is just an
 * icon + heading + descriptive paragraph — the prompts themselves live
 * in the footer and stay visible on every turn. So this component
 * intentionally NO LONGER renders the prompt chips here: the route's
 * single `<SuggestedPrompts>` is the canonical surface.
 */
export function ChatEmptyState() {
  return (
    <div className="flex h-full flex-col items-center justify-center px-6 py-10 text-center">
      <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-full bg-ai-surface text-ai-ink">
        <MessageSquare className="h-5 w-5" aria-hidden="true" />
      </div>
      <h2 className="text-h2 font-semibold text-ink-900">Ask anything about this engagement</h2>
      <p className="mt-2 max-w-md text-body-sm text-ink-500">
        Caliber answers from this engagement&apos;s documents and register entries — every claim
        cites the source. If nothing matches, you&apos;ll see a refusal, never a guess.
      </p>
      <p className="mt-3 text-meta text-ink-500">Pick a starter prompt below or type your own.</p>
    </div>
  );
}
